export const CREATE_USER = "CREATE_USER";
export const GET_USERS = "GET_USERS";
export const DELETE_USER = "DELETE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const GET_SERVED_USERS = "GET_SERVED_USERS";
